import { render } from "./putTime.vue?vue&type=template&id=3660c883&scoped=true"
import script from "./putTime.vue?vue&type=script&lang=js"
export * from "./putTime.vue?vue&type=script&lang=js"

import "./putTime.vue?vue&type=style&index=0&id=3660c883&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3660c883"]])

export default __exports__